import React, { useState } from "react";

import logo from "../assets/images/1.png";

import { Link } from "react-router-dom";

import ClassData from "../Class.json";

import {
  FiMenu,
  FiHome,
  FiPhone,
} from "react-icons/fi";

import {
  AiOutlineClose,
  AiFillFileText,
} from "react-icons/ai";

import {
  FaAngleDown,
  FaAngleUp,
} from "react-icons/fa";

const MobileHeader = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const [isBooksOpen, setBooksOpen] = useState(false);

  const [isKeysOpen, setKeysOpen] = useState(false);

  const links = [
    {
      name: "Test Paper",

      link: "https://bhavyapublications.in/testpaper/",
    },

     {
      name: "Ayansh Test Paper",

      link: "https://bhavyapublications.in/testpaper25/",
    },

    {
      name: "Studio Keys",

      link: "https://bhavyapublications.in/pdfviewerstudios/index.html",
    },


    {
      name: "Ayansh Keys",

      link: "https://bhavyapublications.in/pdfviewerayansh/index.html",
    },

    {
      name: "Vision Keys",

      link: "https://bhavyapublications.in/pdfviewervision/index.html",
    },
  ];

  return (
    <div className="md:hidden sticky top-0 z-50">

      {/* Header */}

      <div className="bg-gradient-to-r from-[#4D96FF] via-[#9B5DE5] to-[#FF6B6B] px-4 py-3 shadow-lg">

        <div className="flex items-center justify-between">

          {/* Logo */}

          <Link to="/">

            <img
              src={logo}
              alt="logo"
              className="h-12"
            />

          </Link>

          {/* Buttons */}

          <div className="flex items-center gap-3">

            {/* Keys */}

            <button
              onClick={() => setKeysOpen(!isKeysOpen)}
              className="w-11 h-11 rounded-full bg-white text-[#FF6B6B] shadow-lg flex items-center justify-center"
            >

              <AiFillFileText size={20} />

            </button>

            {/* Menu */}

            <button
              onClick={() => setMenuOpen(!isMenuOpen)}
              className="w-11 h-11 rounded-full bg-white text-[#4D96FF] shadow-lg flex items-center justify-center"
            >

              {isMenuOpen ?

                <AiOutlineClose size={22} />

                :

                <FiMenu size={22} />

              }

            </button>

          </div>

        </div>

      </div>

      {/* Keys Dropdown */}

      {isKeysOpen && (

        <div className="bg-white shadow-lg mx-3 mt-2 rounded-3xl overflow-hidden">

          {links.map((item, index) => (

            <a
              key={index}

              href={item.link}

              target="_blank"

              rel="noopener noreferrer"

              className="block px-5 py-4 border-b hover:bg-[#FFF8E8]"
            >

              📘 {item.name}

            </a>

          ))}

        </div>

      )}

      {/* Mobile Menu */}

      {isMenuOpen && (

        <div className="bg-white m-3 rounded-3xl shadow-2xl overflow-hidden">

          {/* Home */}

          <Link
            to="/"

            onClick={() => setMenuOpen(false)}
          >

            <div className="px-5 py-5 flex items-center gap-3 border-b">

              <FiHome />

              Home

            </div>

          </Link>

          {/* Books */}

          <button
            onClick={() => setBooksOpen(!isBooksOpen)}
            className="w-full px-5 py-5 flex justify-between items-center border-b"
          >

            <div>

              📚 Books

            </div>

            {isBooksOpen ?

              <FaAngleUp />

              :

              <FaAngleDown />

            }

          </button>

          {/* Classes */}

          {isBooksOpen && (

            <div className="grid grid-cols-2 gap-3 p-4 bg-[#FFF9F4]">

              {ClassData.map((item, id) => (

                <Link
                  key={id}

                  to={item.direct}

                  onClick={() => setMenuOpen(false)}
                >

                  <div className="bg-white rounded-2xl p-4 text-center shadow hover:scale-105 transition">

                    📘

                    <div className="mt-2 text-sm font-semibold">

                      {item.classCategory}

                    </div>

                  </div>

                </Link>

              ))}

            </div>

          )}

          {/* Contact */}

          <Link
            to="/contact"

            onClick={() => setMenuOpen(false)}
          >

            <div className="px-5 py-5 flex items-center gap-3 border-b">

              <FiPhone />

              Contact Us

            </div>

          </Link>

          {/* Quick Links */}

          <div className="p-4">

            <div className="text-sm font-bold text-gray-500 mb-3">

              Quick Access

            </div>

            <div className="grid grid-cols-2 gap-3">

              {links.map((item, index) => (

                <a
                  key={index}

                  href={item.link}

                  target="_blank"

                  rel="noopener noreferrer"

                  className="bg-gradient-to-r from-[#4D96FF] to-[#FF6B6B] text-white text-center rounded-2xl py-3 text-sm font-semibold"
                >

                  {item.name}

                </a>

              ))}

            </div>

          </div>

        </div>

      )}

    </div>
  );
};

export default MobileHeader;